"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notEmpty = exports.getElement = exports.getNode = exports.getNodeUsages = exports.getNodeName = void 0;
const lodash_1 = __importDefault(require("lodash"));
const typeguards_1 = require("../node/typeguards");
const getNodeName = (node) => {
    if (node && 'label' in node && node.label) {
        return node.label;
    }
    if (node && 'name' in node && node.name) {
        return node.name;
    }
    return undefined;
};
exports.getNodeName = getNodeName;
const getFullChildrenIds = (block, id) => {
    var _a;
    const node = (0, exports.getNode)(block, id);
    if ((0, typeguards_1.isShellNode)(node)) {
        if (node === null || node === void 0 ? void 0 : node.elementId) {
            const element = (0, exports.getElement)(block, node.elementId);
            if ((0, typeguards_1.isComplexElement)(element)) {
                const ids = element.value.items.map((item) => item.value);
                return ids;
            }
            if ((0, typeguards_1.isSlotElement)(element) && ((_a = element.value.item) === null || _a === void 0 ? void 0 : _a.value)) {
                return [element.value.item.value];
            }
        }
    }
    return (node === null || node === void 0 ? void 0 : node.children) || [];
};
const getNodeWithFullChildren = (block, id) => {
    const node = block.schema.nodes[id];
    if (!node) {
        return [];
    }
    const children = getFullChildrenIds(block, id);
    const childrenNodes = children.flatMap((id) => getNodeWithFullChildren(block, id)) || [];
    return [node, ...childrenNodes];
};
const getNodeUsages = (block) => {
    const { rootId } = block.schema;
    const usedNodes = getNodeWithFullChildren(block, rootId);
    const shells = usedNodes.filter(typeguards_1.isShellNode);
    const usedElementIds = shells.flatMap((shell) => shell === null || shell === void 0 ? void 0 : shell.elementId).filter(exports.notEmpty);
    const notUsedNodes = Object.values(lodash_1.default.omit(block.schema.nodes, usedNodes.map((node) => node.id)));
    const notUsedElements = Object.entries(lodash_1.default.omit(block.elements, usedElementIds)).map(([id, data]) => (Object.assign(Object.assign({}, data), { id })));
    const usedElements = usedElementIds.map((id) => block.elements[id] || { id });
    return {
        shells,
        usedElements,
        notUsedElements,
        notUsedNodes,
        usedElementIds,
    };
};
exports.getNodeUsages = getNodeUsages;
const getNode = (block, id) => { var _a, _b; return ((_a = block === null || block === void 0 ? void 0 : block.schema) === null || _a === void 0 ? void 0 : _a.nodes) && ((_b = block === null || block === void 0 ? void 0 : block.schema) === null || _b === void 0 ? void 0 : _b.nodes[id]); };
exports.getNode = getNode;
const getElement = (block, id) => block.elements[id];
exports.getElement = getElement;
const notEmpty = (value) => {
    return value !== null && value !== undefined;
};
exports.notEmpty = notEmpty;
